import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { aud, media } from "../../components/extras/ExtrasShell";

export default function PublicProduct() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/extras/p/${slug}`).then(({ data }) => setP(data)).catch(() => setErr(true)); }, [slug]);
  if (err) return <div className="ex min-h-screen p-16 ex-display text-3xl">This product isn't available.</div>;
  if (!p) return <div className="ex min-h-screen p-16">Loading…</div>;
  const l = p.listing || {};
  return (
    <div data-testid="public-product" className="ex min-h-screen">
      <div className="max-w-5xl mx-auto px-8 py-14 grid md:grid-cols-2 gap-12">
        {p.image_id && <img src={media(p.image_id)} alt={l.name} className="w-full aspect-square object-cover rounded-lg" />}
        <div>
          <div className="ex-eyebrow mb-3">PB Travel Angel · Edition {p.edition || 1}</div>
          <h1 className="ex-display text-4xl sm:text-5xl font-semibold">{l.name}</h1>
          <p className="ex-display italic text-lg text-stone-700 mt-3">{l.tagline}</p>
          <div data-testid="public-price" className="ex-display text-3xl mt-6">{aud(l.price_aud)}</div>
          <p className="text-sm leading-relaxed mt-6 whitespace-pre-line">{l.long_description}</p>
          {l.whats_included?.length > 0 && <><div className="ex-eyebrow mt-8 mb-2">What's included</div><ul className="text-sm space-y-1 list-disc pl-5">{l.whats_included.map((x) => <li key={x}>{x}</li>)}</ul></>}
          <div className="flex flex-wrap gap-3 mt-8">
            <a data-testid="public-buy" href="https://pbtravelangel.com" className="ex-btn ex-btn-dark">Buy at pbtravelangel.com</a>
            {p.deliverable_id && <a data-testid="public-sample" href={`${process.env.REACT_APP_BACKEND_URL}/api/extras/public/sample/${slug}`} target="_blank" rel="noreferrer" className="ex-btn ex-btn-line">Free sample</a>}
          </div>
        </div>
      </div>
    </div>
  );
}
